export default __webpack_public_path__ + "static/media/burak-erkovan.9b34c251.png";